import { useRef } from "react";
import { Link } from "react-router-dom";
import { color, motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { FadeUp } from "@/components/Reveal";

const CTABanner = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section className="relative z-10 w-full">
      <FadeUp>
        <div
          ref={ref}
          data-testid="cta-banner"
          className="relative overflow-hidden rounded-[28px] h-[220px] sm:h-[240px] flex items-center"
        >
          <motion.img
            src="/assets/cta-photo.png"
            alt=""
            className="absolute inset-0 w-full h-[130%] object-cover object-center -top-[25%]"
            style={{ y }}
          />
          <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.35) 50%, rgba(0,0,0,0.65) 100%)" }} />
          <div className="relative site-container flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            <h2 className="text-3xl sm:text-5xl lg:text-[80px] font-semibold tracking-[-0.03em] leading-[1.3] max-w-[920px]" style={{
              color: "#D6C8DF",
            }}
            >
              Ready to work with us?
            </h2>
            <Link
              to="/contact"
              data-testid="cta-banner-button"
              className="btn-pill btn-lav !py-3 !px-6 text-[15px] !font-semibold shrink-0"
            >
              Book A Strategic Call
              <ArrowRight size={17} className="btn-arrow" />
            </Link>
          </div>
        </div>
      </FadeUp>
    </section>
  );
};

export default CTABanner;
